import React, { useMemo } from 'react'
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined'
import TimelineOutlined from '@mui/icons-material/TimelineOutlined'
import { compareHomeworkByPathTitle, homeworkPathPrefix, homeworkStatusLabel } from './constants'

export default function PortalSummary({
  courseId,
  courseName,
  studentId,
  homework = [],
  evaluation = {},
  timelineUnit,
  onOpenHomework,
  onOpenGrowth,
}) {
  const pending = homework.filter((item) => ['1', '4'].includes(String(item.status)))
  const canOpen = Boolean(evaluation?.available || evaluation?.insufficient)
  const sortedHomework = useMemo(
    () => [...homework].sort((a, b) => compareHomeworkByPathTitle(a, b, timelineUnit)),
    [homework, timelineUnit],
  )

  return (
    <section className="portal-summary">
      <div className="portal-summary-grid">
        <button
          type="button"
          className="summary-card summary-card-action"
          onClick={() => onOpenHomework?.({ courseId })}
          aria-label="打开校园训练任务"
        >
          <div className="summary-card-head">
            <div className="summary-card-title">
              <AssignmentOutlined className="summary-icon" />
              本课程作业
              {homework.length > 0 && (
                <span className="summary-count">{homework.length}</span>
              )}
              {pending.length > 0 && (
                <span className="summary-pending">{pending.length} 待办</span>
              )}
            </div>
            <span className="summary-link">校园训练任务</span>
          </div>
          {!homework.length ? (
            <p className="summary-empty">暂无作业，点击打开校园训练任务</p>
          ) : (
            <div className="summary-homework-list">
              {sortedHomework.map((item) => {
                const prefix = homeworkPathPrefix(item, timelineUnit)
                return (
                  <div key={item.id} className="summary-row">
                    <span className="summary-row-title" title={prefix ? `${prefix} · ${item.title}` : item.title}>
                      {prefix ? (
                        <>
                          <span className="summary-row-prefix">{prefix}</span>
                          <span className="summary-row-sep"> · </span>
                        </>
                      ) : null}
                      {item.title}
                    </span>
                    <span className={`summary-status status-${item.status}`}>
                      {homeworkStatusLabel(item.status)}
                    </span>
                  </div>
                )
              })}
            </div>
          )}
        </button>

        <button
          type="button"
          className={`summary-card summary-card-action summary-card-growth${!canOpen ? ' is-disabled' : ''}`}
          disabled={!canOpen}
          onClick={() => canOpen && onOpenGrowth?.({ courseId, courseName })}
          aria-label="查看成长评价报告"
        >
          <div className="summary-card-head">
            <div className="summary-card-title">
              <TimelineOutlined className="summary-icon" />
              成长评价
            </div>
            <span className="summary-link">{canOpen ? '查看报告' : '暂无报告'}</span>
          </div>
          {evaluation?.available ? (
            <p className="summary-text">
              {evaluation.count || 0} 次评价
              {evaluation.latestScore != null ? ` · 最近 ${evaluation.latestScore}` : ''}
            </p>
          ) : (
            <p className="summary-text">
              {evaluation?.insufficient
                ? (evaluation.message || '完成更多作业评价后可查看轨迹')
                : '完成作业评价后可查看能力画像'}
            </p>
          )}
        </button>
      </div>

    </section>
  )
}
